import session from '@/app/providers/session';

export function getDeviceIdHeaders() {
  return {
    headers: session.applyDeviceIdHeaders(),
  };
}
